"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var react_dom_1 = require("react-dom");
var utils_1 = require("../../utils");
var LayerContainer_1 = require("./LayerContainer");
var Layer = /** @class */ (function (_super) {
    tslib_1.__extends(Layer, _super);
    function Layer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.originalFocusedElement = document.activeElement;
        _this.originalFocusedElementParentNode = document.parentNode;
        _this.layerContainer = utils_1.getNewContainer();
        return _this;
    }
    Layer.prototype.componentWillUnmount = function () {
        var _this = this;
        if (this.originalFocusedElement) {
            if (this.originalFocusedElement.focus) {
                // wait for the fixed positioning to come back to normal
                // see layer styling for reference
                setTimeout(function () {
                    _this.originalFocusedElement.focus();
                }, 0);
            }
            else if (this.originalFocusedElementParentNode && this.originalFocusedElementParentNode.focus) {
                // required for IE11 and Edge
                this.originalFocusedElementParentNode.focus();
            }
        }
        document.body.removeChild(this.layerContainer);
    };
    Layer.prototype.render = function () {
        return react_dom_1.createPortal(React.createElement(LayerContainer_1.LayerContainer, tslib_1.__assign({}, this.props)), this.layerContainer);
    };
    Layer.defaultProps = {
        full: false,
        margin: 'none',
        modal: true,
        position: 'center',
        responsive: true
    };
    return Layer;
}(React.Component));
exports.Layer = Layer;
//# sourceMappingURL=Layer.js.map